module.exports = __webpack_public_path__ + "images/fucker-cd4b18bd1957d713e57149433f44c20c.png";